import React from "react";
import {useTranslation} from "react-i18next";
//local
import {Info} from "components/Info";
import cn from "classnames";

const columnClass = "requests-card_head__column __wrapper";

const PublicRfpsTableHead = ({isExternal}) => {
  const {t} = useTranslation();

  return (
    <div className="requests-card_head">
      <div className={cn(`${columnClass} __category`, {__ext: isExternal})}>
        {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_01")}
      </div>
      <div className={cn(`${columnClass} __region`, {__ext: isExternal})}>
        {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_02")}
      </div>
      <div className={cn(`${columnClass} __published-at`, {__ext: isExternal})}>
        {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_08")}
      </div>
      <div className={cn(`${columnClass} __time-left`, {__ext: isExternal})}>
        {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_03")}
        <Info
          tooltip="PUBLIC_RFPS_PAGE_TABLE_COLUMN_03_TOOLTIP"
          centerText
          addClass="ml-1"
        />
      </div>
      <div className={cn(`${columnClass} __customers`, {__ext: isExternal})}>
        {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_04")}
      </div>
      {!isExternal && (
        <div className={cn(`${columnClass} __project-name`, {__ext: isExternal})}>
          {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_05")}
        </div>
      )}

      <div className={cn(`${columnClass} __rfp-name`, {__ext: isExternal})}>
        {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_06")}
      </div>

      {!isExternal && (
        <div className={cn(`${columnClass} __turnover`, {__ext: isExternal})}>
          {t("PUBLIC_RFPS_PAGE_TABLE_COLUMN_07")}
          <Info
            tooltip="PUBLIC_RFPS_PAGE_TABLE_COLUMN_07_TOOLTIP"
            centerText
            addClass="ml-1"
          />
        </div>
      )}
    </div>
  );
};

export default PublicRfpsTableHead;
